import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/AdminLayout";
import { DataTable } from "../../components/DataTable";
import { adminHeaders, api } from "../../lib/api";

export function AdminFinancePage() {
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);
  useEffect(() => { api<{ daily: Record<string, unknown>[] }>("/api/admin/finance", { headers: adminHeaders() }).then((data) => setRows(data.daily)).catch(console.error); }, []);
  return <AdminLayout title="財務摘要預留"><DataTable rows={rows} /></AdminLayout>;
}
